import React, { useEffect } from 'react';
import { App as AntApp } from 'antd';
import { AppRouter } from './router/AppRouter';
import { setAppMessageInstance } from './utils/appMessage';
import { setAppModalInstance } from './utils/appModal';
import './App.css';

/**
 * `<App>`(index.tsx) 안에서 만들어진 message 인스턴스를 정적 호출부(`appMessage`)로 연결한다.
 * 이게 있어야 다크 모드에서도 토스트가 ConfigProvider 테마(배경·글자색)를 따라간다.
 */
const MessageBridge: React.FC = () => {
  const { message, modal } = AntApp.useApp();

  useEffect(() => {
    // <App> 밖(테스트 등)에서는 빈 객체가 오므로 메서드가 있을 때만 등록한다.
    if (typeof message?.error !== 'function') return undefined;
    setAppMessageInstance(message);
    return () => setAppMessageInstance(null);
  }, [message]);

  // 확인 창(③ 스토어 반영 요약 등, 감사 #538)도 같은 방식 — 다크 모드 테마 · 컨텍스트를 받게.
  useEffect(() => {
    if (typeof modal?.confirm !== 'function') return undefined;
    setAppModalInstance(modal);
    return () => setAppModalInstance(null);
  }, [modal]);

  return null;
};

function App() {
  return (
    <>
      <MessageBridge />
      <AppRouter />
    </>
  );
}

export default App;
